var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveCohortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1763",
    d: "M9.9 10.5H1.1C0.768629 10.5 0.5 10.2314 0.5 9.9V1.1C0.5 0.768629 0.768629 0.5 1.1 0.5H5.29289L10.5 5.70711V9.9C10.5 10.2314 10.2314 10.5 9.9 10.5Z",
    stroke: "#201CE0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5011",
    cx: 4.94688,
    cy: 4.9498,
    r: 1.65,
    stroke: "#201CE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1764",
    d: "M6.59688 10.4002H7.09688V9.9002V9.3502C7.09688 8.16278 6.13429 7.2002 4.94688 7.2002C3.75946 7.2002 2.79688 8.16278 2.79688 9.3502V9.9002V10.4002H3.29688H6.59688Z",
    stroke: "#201CE0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006018"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1186",
    d: "M10.4453 0V3.3",
    stroke: "#201CE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1187",
    d: "M12.0938 1.6499L8.79375 1.6499",
    stroke: "#201CE0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveCohortIcon);
export default __webpack_public_path__ + "static/media/save-cohort-icon.44ffb83a90af4de6bd970314b06e7cdb.svg";
export { ForwardRef as ReactComponent };